import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=d338e06e&scoped=true&"
import script from "./DataForm.vue?vue&type=script&lang=ts&"
export * from "./DataForm.vue?vue&type=script&lang=ts&"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=d338e06e&prod&lang=css&"
import style1 from "./DataForm.vue?vue&type=style&index=1&id=d338e06e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d338e06e",
  null
  
)

export default component.exports